import React from 'react';
import { Dimensions } from 'react-native';
import { Appbar } from 'react-native-paper';
import { SafeAreaView } from 'react-native-safe-area-context';

import styles from './lesson-player-navbar.style';
import { SizeBreakpoint } from '../../../../enums/size-breakpoint';
import { useColors, useLessonContext } from '../../../../hooks';
import { NavbarIconButton } from '../../../navbar-icon-button/navbar-icon-button';

interface LessonPlayerNavbarProps {
  title?: string;
  left?: React.ReactNode;
  right?: React.ReactNode;
}

export function LessonPlayerNavbar({
  title,
  left,
  right,
}: LessonPlayerNavbarProps) {
  const colors = useColors();
  const {
    indexVisible,
    toggleIndexVisibility,
    translationActive,
    toggleTranslation,
    isTranslationButtonEnabled,
    showTranslationButton,
  } = useLessonContext();
  const { width: windowWidth } = Dimensions.get('window');

  if (windowWidth > SizeBreakpoint.MD) {
    return null;
  }

  return (
    <SafeAreaView edges={['top']}>
      <Appbar
        style={[
          styles.container,
          { backgroundColor: colors.background, borderColor: colors.grayLight },
        ]}
        dark={false}
      >
        {left}
        <Appbar.Content title={title} />
        <NavbarIconButton
          icon="list-alt"
          active={indexVisible}
          onPress={toggleIndexVisibility}
        />
        {showTranslationButton && (
          <NavbarIconButton
            disabled={!isTranslationButtonEnabled}
            icon="language"
            active={translationActive}
            onPress={toggleTranslation}
          />
        )}
        {right}
      </Appbar>
    </SafeAreaView>
  );
}
